import { useMemo } from "react";
import { TASK_TYPE_ID } from "../constants/filterIds";
import { useTranslation } from "@coworker/locales";
import { SelectItem } from "../../shared/filters/types/filter";
import { formatLocationName } from "../helpers/formatLocationName";

const NO_OPTIONS: SelectItem[] = [];

const buildMultiSelectFilterOptions = (
  t: (key: string, options?: any) => string,
  departments: string[]
) => {
  const options: SelectItem[] = departments.map((department) => {
    return {
      title: formatLocationName(department, t),
      value: department,
      dependsOnFilterId: TASK_TYPE_ID,
    };
  });
  return options;
};

const buildGroupedMultiSelectFilterOptions = (
  t: (key: string, options?: any) => string,
  hfbDepartments: string[],
  otherDepartments: string[]
) => {
  const options: SelectItem[] = [
    {
      title: t(`hfbString`),
      options: hfbDepartments.map((department) => ({
        title: formatLocationName(department, t),
        value: department,
        dependsOnFilterId: TASK_TYPE_ID,
      })),
    },
    {
      title: t(`otherString`),
      options: otherDepartments.map((department) => ({
        title: formatLocationName(department, t),
        value: department,
        dependsOnFilterId: TASK_TYPE_ID,
      })),
    },
  ];
  return options;
};

const buildDepartmentFilterOptions = (
  t: (key: string, options?: any) => string,
  taskTypeValueValue: string,
  departments: string[]
) => {
  const hfbDepartments = departments
    .filter((department) => department.match(/[0-9][0-9]/))
    .sort();
  const otherDepartments = departments
    .filter((department) => !department.match(/[0-9][0-9]/))
    .sort((str1, str2) => (str2 === "OTHER" ? -1 : str1.localeCompare(str2)));

  if (taskTypeValueValue === "mfaq") {
    return buildGroupedMultiSelectFilterOptions(
      t,
      hfbDepartments,
      otherDepartments
    );
  } else {
    return buildMultiSelectFilterOptions(t, [
      ...hfbDepartments,
      ...otherDepartments,
    ]);
  }
};

export function useLocationsOptions(
  taskTypeValueValue: string,
  taskLocations: string[]
): SelectItem[] {
  const { t } = useTranslation();
  return useMemo(() => {
    if (!taskLocations) return NO_OPTIONS;

    return buildDepartmentFilterOptions(t, taskTypeValueValue, taskLocations);
  }, [taskLocations, taskTypeValueValue, t]);
}
